/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavWaypoint
 */
export interface OutputUavWaypoint {
    /**
     * 
     * @type {string}
     * @memberof OutputUavWaypoint
     */
    kind?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavWaypoint
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavWaypoint
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavWaypoint
     */
    lng?: number;
}

/**
 * Check if a given object implements the OutputUavWaypoint interface.
 */
export function instanceOfOutputUavWaypoint(value: object): boolean {
    return true;
}

export function OutputUavWaypointFromJSON(json: any): OutputUavWaypoint {
    return OutputUavWaypointFromJSONTyped(json, false);
}

export function OutputUavWaypointFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavWaypoint {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': json['kind'] == null ? undefined : json['kind'],
        'label': json['label'] == null ? undefined : json['label'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
    };
}

export function OutputUavWaypointToJSON(value?: OutputUavWaypoint | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'kind': value['kind'],
        'label': value['label'],
        'lat': value['lat'],
        'lng': value['lng'],
    };
}

